import { render, staticRenderFns } from "./TeensHome.vue?vue&type=template&id=1f1bb0ac&scoped=true&"
import script from "./TeensHome.vue?vue&type=script&lang=js&"
export * from "./TeensHome.vue?vue&type=script&lang=js&"
import style0 from "./TeensHome.vue?vue&type=style&index=0&id=1f1bb0ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1bb0ac",
  null
  
)

export default component.exports